import ICsvData from "../models/ICsvData";
import CsvValidation from "../models/CsvValidation";

export enum ActionType {
  UploadCsv = "UPLOAD_CSV",
}

/*
 * Define return types of our actions
 * Every action returns a type and a payload
 */
export interface IUploadCsvAction {
  type: ActionType.UploadCsv;
  payload: {
    csvData: ICsvData[];
    isValid: CsvValidation;
  };
}

/*
 * Define our actions creators
 * We are returning the right Action for each function
 */
export function uploadCsv(
  csvData: ICsvData[],
  isValid: CsvValidation
): IUploadCsvAction {
  return {
    type: ActionType.UploadCsv,
    payload: {
      csvData,
      isValid,
    },
  };
}

/*
 * Define the Action type
 * It can be one of the types defining in action/CsvUploaderAction file
 */
export type Action = IUploadCsvAction;



// WEBPACK FOOTER //
// ./src/scripts/actions/CsvUploaderActions.ts